export const FETCH_USER_MEMBERSHIP_VOLUME_LOADING =
  "FETCH_USER_MEMBERSHIP_VOLUME_LOADING";
export const FETCH_USER_MEMBERSHIP_VOLUME = "FETCH_USER_MEMBERSHIP_VOLUME";
export const IS_FREE_TRIAL = "IS_FREE_TRIAL";
export const UPDATE_RENEWAL_NOTICE_DATA = "UPDATE_RENEWAL_NOTICE_DATA";
